import { checkoutShouldShowBookingProtection } from 'checkout/selectors/checkoutSectionsSelectors'
import { getQuoteFromBookingProtectionQuotes } from 'checkout/selectors/request/bookingProtection'
import { sum } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import { isEnabledLuxPlusDiscountedBookingProtection } from 'luxPlus/selectors/featureToggle'
import { getBookingProtectionItemsView } from 'checkout/selectors/view/bookingProtection'

export const getAvailableBookingProtectionBenefits = createSelector(
  (state: App.State) => isEnabledLuxPlusDiscountedBookingProtection(state),
  (state: App.State) => checkoutShouldShowBookingProtection(state),
  (state: App.State) => getBookingProtectionItemsView(state),
  (state: App.State) => getQuoteFromBookingProtectionQuotes(state),
  (state: App.State) => state.bookingProtection.fetchingQuotes,
  (state: App.State) => state.bookingProtection.triedFetchingQuotes,
  (
    isEnabledLuxPlusDiscountedBookingProtection,
    shouldShowBookingProtection,
    bookingProtectionItemsView,
    quote,
    fetching,
    triedFetchingQuotes,
  ): App.Checkout.LuxPlusBookingProtectionBenefits => {
    const luxPlusPrice = quote?.luxPlusPrice ?? 0
    const price = quote?.price ?? 0

    const totalPrice = sum(bookingProtectionItemsView.data, item => item.totals.price)
    const totalMemberPrice = sum(bookingProtectionItemsView.data, item => item.totals.memberPrice)
    const totalMemberPriceSavings = totalPrice - totalMemberPrice

    if (!isEnabledLuxPlusDiscountedBookingProtection) {
      return {
        isAvailable: false,
        fetching: false,
        luxPlusDiscountPercentage: 0,
        luxPlusDiscountValueDisplayThreshold: 0,
        totalMemberMaxSavings: 0,
        totalMemberPriceSavings: 0,
        totalPrice: 0,
        totalMemberPrice: 0,
        totalBaseMemberPrice: 0,
      }
    }

    return {
      isAvailable: !!(isEnabledLuxPlusDiscountedBookingProtection && shouldShowBookingProtection),
      fetching: !!(triedFetchingQuotes && Object.values(fetching).some(fetching => fetching)),
      luxPlusDiscountPercentage: quote?.luxPlusDiscountPercentage ?? 0,
      luxPlusDiscountValueDisplayThreshold: quote?.luxPlusDiscountValueDisplayThreshold ?? 0,
      totalMemberMaxSavings: luxPlusPrice > 0 ? price - luxPlusPrice : 0,
      totalMemberPriceSavings,
      totalPrice,
      totalMemberPrice,
      // TODO - revisit this when benefit is available to customers
      totalBaseMemberPrice: totalMemberPrice,
    }
  },
)
